EASY.timeLog.showPeriodDaysField = function (period_selectbox_selector, triggerChange) {
    var triggerChange = typeof triggerChange !== 'undefined' ? triggerChange : false;

    $(document).on('change', period_selectbox_selector, function() {
        var option = $(this).find('option:selected');
        var descriptionHtml = '<em>' + option.data('description') + '</em>';
        var period_days_container = $(period_selectbox_selector + '_days_container');
        var period_days_description_container = $(period_selectbox_selector + '_days_description_container');
        var period_days2_container = $(period_selectbox_selector + '_days2');

        if (option.val().indexOf('m_to_n') !== -1) {
            period_days_container.show();
            period_days2_container.show();
            period_days_description_container.html(descriptionHtml);
        } else if (option.val().indexOf('n_days') !== -1) {
            period_days_container.show();
            period_days2_container.hide();
            period_days_description_container.html(descriptionHtml);
        } else {
            period_days_container.hide();
            period_days2_container.hide();
        }
    });

    if (triggerChange) {
        $(period_selectbox_selector).change();
    }
};
